import React, { Component } from 'react';
import styles from './index.module.less';
import menuData from './notice-menu-data';
import getMockListData from './mock-list-data'
import DocList from '@/components/DocList'
import Doc from '@/components/Doc'
import NoticeLayout from '@/components/Notice'
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';

const mapStateToProps = (rootState) => {
  return { 
    currentRoute: rootState.router,
    notices: rootState.notices
  };
};

@connect(mapStateToProps)
class NoticesComponent extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      currentRoute,
    } = this.props; 

    const mockListData = getMockListData();

    const onListClick = (item) => {
      dispatch.router.push(`/notices?docId=${item.id}`);
    }
    const onMenuClick = (docType) => {
      dispatch.router.push(`/notices?docType=${docType}`);
    }
    const setMenuItemKeyPath = (itemPath) => {
      dispatch.notices.updatePath({
        itemPath
      });
    }
    const location = this.props.notices;

    const getSelectedData = () => {
      const levelList = typeof location.docType === 'string' ? location.docType.split(',') : [];
      let dataSelect = (location.docType === '' || location.docType === '0') ? mockListData : mockListData.filter(elem => elem.type === location.docType);
      return dataSelect;
    }
    const listItem = (
      <DocList
        dataSource={getSelectedData()}
        className={styles.doclist}
        listType='notices'
        onClick={onListClick}
      ></DocList>
    );
    const docItem = (
      <Doc
        dataSource={mockListData.filter(elem => elem.id == location.docId)}
        className={styles.doclist}
        docType={'notices'}   
      ></Doc>
    );
    const renderItem = () => { return location.docId === '' ? listItem : docItem };
    return (
      <NoticeLayout
        menuData={menuData}
        currentRoute={currentRoute}
        setMenuItemKeyPath={setMenuItemKeyPath}
        setDocType={onMenuClick}
        itemPath={location.itemPath}
        listType='notices'
        sideType='notices'
        titleName='平台公告'>
        <div className={styles.content}>
        {renderItem()}
        </div>
      </NoticeLayout>
    )
  }
}


export default NoticesComponent;